"use strict";

exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/_opy_VqP/0/cw/ws/uvocorp.com/gatsby/~/dom-helpers/util/inDOM.js
// module id = 119
// module chunks = 168707334958949